import {
	find,
	filter,
	minBy,
	flatMap
} from "lodash";
import {
	EVENT_VALUE_CHANGED,
	EVENT_FIELD_DISABLE,
	EVENT_FIELD_ENABLE,
	EVENT_SET_FEATURE_DATA,
	FIELD_TEMPLATES,
	EVENT_CLEAR_VALUE
} from "constants.js";
import fieldHelpers from "../components/field-helpers/lookup.config.js";
import { IS_NOT_AVAILABLE_OPTIONS } from "../constants.js";
import { veslGeometriesToFeatureCollection } from "../utils/geometries-to-geojson.js";

function featureHelper($base64) {
	this.getNotAvailableFeature = getNotAvailableFeature;
	this.getCustomInputFeature = getCustomInputFeature;
	this.mapPoint = mapPoint;
	this.checkNotAvailable = checkNotAvailable;
	this._base64 = $base64;

	function checkNotAvailable(field, compareValue) {
		if(field.IsNotAvailableEnabled === false
			|| field.IsNotAvailableEnabled === undefined
			|| field.IsNotAvailableEnabled === IS_NOT_AVAILABLE_OPTIONS.never) {
			return false;
		}

		if((field.IsNotAvailableEnabled === true || field.IsNotAvailableEnabled === null) && compareValue === IS_NOT_AVAILABLE_OPTIONS.always) {
			return true;
		}

		return field.IsNotAvailableEnabled === compareValue;
	}

	function getNotAvailableFeature(field, initialIsNotAvailableState, action) {
		const name = fieldHelpers.NotAvailable.name;
		const disable = field.isReadonly || field.isDisabled;

		return {
			name: name,
			fieldId: field.Id,
			disabled: disable,
			state: initialIsNotAvailableState,
			action: action
		};
	}

	function getCustomInputFeature(field, initialIsCustomInputState, action) {
		const name = fieldHelpers.CustomInput.name;
		const disable = field.isReadonly || field.isDisabled;

		return {
			name: name,
			fieldId: field.Id,
			disabled: disable,
			state: initialIsCustomInputState,
			action: action
		};
	}

	function mapPoint(feat, fields, scope, eventBus) {
		const trigger = minBy(feat.Fields, "Order");
		const locationFields = filter(fields, f => f.Template === FIELD_TEMPLATES.Location);
		const areaDefinition = filter(fields, f => f.Key.Code == "TRIP.AREAS.SINGLE");
		const triggerField = find(fields, f => f.Id === trigger.Field.Id);

		feat.locationFields = [];

		locationFields.forEach(f => {
			f.features = [feat];
			feat.locationFields.push({ Id: f.Id, fieldId: f.Id, fieldKey: f.Key.Code, Key: { Code: f.Key.Code } });
		});

		areaDefinition.forEach(f => {
			f.features = [feat];
		});

		if(triggerField.Type.Code !== "AREA") {
			eventBus.register(EVENT_VALUE_CHANGED(trigger.Field.Id), (e, params) => {
				const entity = params.fullEntity ? params.fullEntity : params.value;
				if(entity && entity.Form && entity.Form.Fields.length === 1) {
					const fieldDataPoints = entity.Form.Fields[0];

					const shapeFields = flatMap(feat.data, f => {
						return f.Id === fieldDataPoints.Id &&
							flatMap(fieldDataPoints.Data, dp =>
								filter(f.Data, (d) => dp.Id === d.Id));
					});
					const geoJsons = flatMap(shapeFields, sf =>
						(sf.Shape || {}).GeoJson
							? JSON.parse(this._base64.decode(sf.Shape.GeoJson))
							: veslGeometriesToFeatureCollection(sf)
					);
					const areaIds = flatMap(shapeFields, sf => sf.Id);

					eventBus.trigger(EVENT_SET_FEATURE_DATA(feat.Type), { geoJsons, locationFields, areaIds });

					if(!triggerField.isReadonly) {
						locationFields.forEach(f => {
							const event = entity ? EVENT_FIELD_ENABLE(f.Id) : EVENT_FIELD_DISABLE(f.Id);

							eventBus.trigger(event);
						});
					}
				}
				else if(params.isInitializing !== true) {
					locationFields.forEach(f => {
						eventBus.trigger(EVENT_FIELD_DISABLE(f.Id));
						eventBus.trigger(EVENT_CLEAR_VALUE(f.Id), { doNotSave: true });
					});
				}
			}, scope);
		}
		else {
			const shapeFields = flatMap(feat.data, f => {
				return f.Data;
			});
			const geoJsons = flatMap(shapeFields, sf =>
				(sf.Shape || {}).GeoJson
					? JSON.parse(this._base64.decode(sf.Shape.GeoJson))
					: veslGeometriesToFeatureCollection(sf)
			);
			feat.geoJsons = geoJsons;
			locationFields.forEach(f => f.isDisabled = false);
		}
	}
}

export default angular
	.module("vesl.services.feature-helper", [])
	.service("featureHelper", featureHelper).name;
